// extracted by mini-css-extract-plugin
export default {"error404":"Error404_error404__y7hDS","wrapper":"Error404_wrapper__SpHXi"};